//ANGULAR IMPORTS
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

//ANGULAR PLUGINS IMPORTS
import { Angular2TokenService } from "angular2-token";

//COMPONENTS IMPORTS
import { AppComponent } from './app.component';
import { DashboardComponent } from "./dashboard/dashboard.component";

//TEM QUE IMPORTAR O COMPONENTE PARA PODER USA-LO
import { NavbarComponent } from './navbar/navbar.component';
import { SignInFormComponent } from "./sign-in-form/sign-in-form.component";
import { SignUpFormComponent } from "./sign-up-form/sign-up-form.component";
import { TaskSearchComponent } from "./navbar/task-search/task-search.component";
import { TasksComponent } from './tasks/tasks.component';
import { TaskDetailComponent } from './tasks/task-detail/task-detail.component';

//SERVICES IMPORTS
import { TaskService } from "./tasks/shared/task.service";
import { AuthService } from "./shared/auth.service";

//MODULES IMPORTS
import { AppRoutingModule } from "./app-routing.module";

//IN MEMORY WEB API
//import { InMemoryWebApiModule } from "angular-in-memory-web-api";
//import { InMemoryTaskDataService } from "./in-memory-task-data.service";

//RXJS OPERATORS
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/debounceTime"; //PARA ESPERAR 
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/switchMap";//IMPORTANDO O SWITCHMAP PARA USA-LO 

//RXJS EXTENSIONS
import "rxjs/add/observable/of";
import "rxjs/add/observable/throw";

//JQUERYS PLUGINS
import * as $ from 'jquery'; //QUANDO USAR $ SERÁ COMO JQUERY
//import * as datepicker from 'gijgo'; //PARA RECONHECER O datetimepicker QUANDO FOR CHAMADO
//import { DatePickerDirective } from './datepicker.directive';
import * as datetimepicker from 'bootstrap4-datetimepicker';

//DATATABLE
import { DataTablesModule } from 'angular-datatables';

//PRIME NG
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {GrowlModule} from 'primeng/growl';
import {CheckboxModule} from 'primeng/checkbox';
import {MessagesModule} from 'primeng/messages';
import {MessageModule} from 'primeng/message';
import {FileUploadModule} from 'primeng/fileupload';
import {ProgressBarModule} from 'primeng/progressbar';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    NavbarComponent, //TEM QUE DELCARA-LO TAMBEM!!!
    SignInFormComponent,
    SignUpFormComponent,
    TaskSearchComponent,
    TasksComponent,
    TaskDetailComponent
    //DatePickerDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    AppRoutingModule,
    DataTablesModule,
    TableModule,
    ButtonModule,
    NoopAnimationsModule,
    TooltipModule,
    DialogModule,
    ConfirmDialogModule,
    GrowlModule,
    CheckboxModule,
    MessagesModule,
    MessageModule,
    FileUploadModule,
    ProgressBarModule
    
    //InMemoryWebApiModule.forRoot(InMemoryTaskDataService)
    //InMemoryWebApiModule.forRoot(InMemoryTaskDataService, {apiBase: "api"})//IMPORTA A CLASSE PASSADO A OUTRA CLASS COMO PARAMETRO
  ],
  providers: [ 
    TaskService,
    AuthService,
    Angular2TokenService,
    ConfirmationService,
    {provide: LocationStrategy, useClass: HashLocationStrategy} 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/app.module.ts